import { useCallback, useMemo } from 'react'
import { useFinancialModelSettingsStore } from '@/feature/financial-model/settings/store/financialModelSettingsStore'
import { getPeriodType } from '@/lib/utils/tables'

export const useGetPeriodType = (finacialModelID: string) => {
  const financialModelTimerframeSettings = useFinancialModelSettingsStore(state => state.settings[finacialModelID].timeframe)

  const extractPeriodType = useCallback(
    (period: string) =>
      getPeriodType({
        period,
        historical: financialModelTimerframeSettings?.historical!,
        forecast: financialModelTimerframeSettings?.forecast!
      }),
    [financialModelTimerframeSettings?.forecast, financialModelTimerframeSettings?.historical]
  )

  return useMemo(() => extractPeriodType, [extractPeriodType])
}
